import { render, staticRenderFns } from "./PFCompanyDashboard.vue?vue&type=template&id=57b1de4b&scoped=true"
import script from "./PFCompanyDashboard.vue?vue&type=script&lang=js"
export * from "./PFCompanyDashboard.vue?vue&type=script&lang=js"
import style0 from "./PFCompanyDashboard.vue?vue&type=style&index=0&id=57b1de4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b1de4b",
  null
  
)

export default component.exports